import React from 'react';
import { Box, Button } from '@mui/material';
import { Form } from 'formik';
import * as Yup from 'yup';
import { MuiForm } from 'lib/Form';
import { TextFormField } from 'lib/form/fields/TextFormField';
import { MuiFormLabel } from 'lib/form/MuiFormLabel';
import { LoadingButton } from 'ui/buttons/LoadingButton';

export interface IAddApiKeyFormValues {
    description: string;
    applicationIdPrefix: string;
}

interface IAddApiKeyFormProps {
    onClose: () => void;
    isLoading: boolean;
    onSubmit: (values: IAddApiKeyFormValues) => void;
}

const initial: IAddApiKeyFormValues = { description: '', applicationIdPrefix: '' };

const validationSchema = Yup.object().shape({
    description: Yup.string().required('This field is required.'),
    applicationIdPrefix: Yup.string()
});

export const AddApiKeyForm: React.FC<IAddApiKeyFormProps> = ({ onClose, isLoading, onSubmit }) => (
    <MuiForm onSubmit={onSubmit} initialValues={initial} validationSchema={validationSchema}>
        {({ submitForm, isSubmitting }) => (
            <Form>
                <TextFormField name="description" label={<MuiFormLabel required>Description</MuiFormLabel>} />
                <TextFormField
                    name="applicationIdPrefix"
                    label={<MuiFormLabel>Application ID Prefix</MuiFormLabel>}
                    description="A short prefix to help identify the application id"
                />
                <Box display="flex" flexDirection="row" justifyContent="flex-end" marginTop={1.5}>
                    <Button onClick={onClose} variant="outlined" sx={{ mr: 1 }}>
                        Cancel
                    </Button>
                    <LoadingButton
                        variant="contained"
                        color="primary"
                        disabled={isSubmitting || isLoading}
                        loading={isSubmitting || isLoading}
                        onClick={submitForm}
                    >
                        Add API Key
                    </LoadingButton>
                </Box>
            </Form>
        )}
    </MuiForm>
);
